<template>
  <span> {{ translatedText }} </span>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
// import translations                  from '@/components/translations/translations';
import store                         from '@/store';
import { LanguageEnum }              from '@/enums/LanguageEnum';

const TranslatedTextComponent: object = defineComponent({
  components: {},
  name: 'TranslatedTextComponent',
  props: {
    translation: {
      type: String,
      default: '',
      name: 'translation',
    },
  },
  setup(props) {
    const translatedText = computed((): string => {
      const translationKey = props.translation as any;
      const lang = store.getters.getCurrentLang;
      const { translations } = store.state as any;

    //   console.log(lang);

    //   if (!translations[translationKey]) {
    //     console.error(props.translation);
    //   }

      if (translations[translationKey]) {
        return translations[translationKey][LanguageEnum[lang]];
      }

      return '';
    });

    return {
      translatedText,
    };
  },
});
export default TranslatedTextComponent;
</script>
